import React from "react";
import { Navigate } from "react-router";
import { useSelector } from "react-redux";
import { getCurrentUser, rehydrateSessionFromLocal } from "../../core/common/authSession";

interface Props {
  children: React.ReactNode;
  requiredRole?: string;
  redirectTo?: string;
}

const ProtectedRoute: React.FC<Props> = ({ children, requiredRole, redirectTo = "/" }) => {
  // Wait for Firebase to finish initialising before redirecting
  const authLoading = useSelector((state: any) => state.auth.loading);
  if (authLoading) return null;

  // Sync localStorage → sessionStorage (for new tabs / hard refresh)
  rehydrateSessionFromLocal();
  const user = getCurrentUser() as (Record<string, any> | null);

  if (!user) return <Navigate to={redirectTo} replace />;
  if (requiredRole && user.user_type !== requiredRole) return <Navigate to={redirectTo} replace />;

  return <>{children}</>;
};

export default ProtectedRoute;
